import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import Header from "../Include/Header";
import Sidebar from "../Include/Sidebar";
import Footer from "../Include/Footer";
import Loader from "../Include/Loader";
import { Pagination, Search } from "../Table";
import DropDown from "../../../Components/DropDown";

import { getAdminBomList } from "../../../Store/Admin/believe/bom/GetBomList";
import { deleteAdminBom } from "../../../Store/Admin/believe/bom/DeleteBom";
import { duplicateAdminBom } from "../../../Store/Admin/believe/bom/DuplicateBom";
import { downloadAdminBomPdf } from "../../../Store/Admin/believe/bom/DownloadBomPdf";
import { exportAdminBomExcel } from "../../../Store/Admin/believe/bom/ExportBomExcel";
import { generatePrFromAdminBom } from "../../../Store/Admin/believe/bom/GeneratePrBom";

const BomList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    dispatch(getAdminBomList());
  }, []);

  const { data: bomResponse, loading } = useSelector(
    (state) => state?.getAdminBomList || {}
  );

  const rawList = bomResponse?.data?.data || [];

  const filteredData = useMemo(() => {
    if (!rawList) return [];
    if (!search) return rawList;
    const s = search.toLowerCase();
    return rawList.filter((elem) =>
      elem?.bom_no?.toLowerCase()?.includes(s) ||
      elem?.client_snapshot?.name?.toLowerCase()?.includes(s) ||
      elem?.subject?.toLowerCase()?.includes(s) ||
      elem?.quotation_ref_no?.toLowerCase()?.includes(s)
    );
  }, [rawList, search]);

  const totalItems = filteredData.length;

  const commentsData = useMemo(() => {
    const start = (currentPage - 1) * limit;
    return filteredData.slice(start, start + limit);
  }, [filteredData, currentPage, limit]);

  const handleDelete = (id, title) => {
    Swal.fire({
      title: `Are you sure want to delete ${title}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteAdminBom(id)).then((response) => {
          const { message, success } = response?.payload || {};
          if (success) {
            toast.success(message || "BOM deleted successfully");
            dispatch(getAdminBomList());
          }
        });
      }
    });
  };

  const handleRefresh = () => {
    setSearch("");
    dispatch(getAdminBomList());
  };

  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleDownloadPdf = (id) => {
    toast.loading("Generating PDF...", { id: "pdf-toast" });
    dispatch(downloadAdminBomPdf(id)).then((res) => {
      toast.dismiss("pdf-toast");
      if (res?.payload?.success && res?.payload?.data?.url) {
        window.open(res.payload.data.url, "_blank");
        toast.success("PDF opened successfully");
      }
    });
  };

  const handleExportExcel = (id) => {
    toast.loading("Exporting Excel...", { id: "excel-toast" });
    dispatch(exportAdminBomExcel(id)).then((res) => {
      toast.dismiss("excel-toast");
      if (res?.payload?.success && res?.payload?.data?.url) {
        window.open(res.payload.data.url, "_blank");
        toast.success("Excel exported successfully");
      }
    });
  };

  const handleDuplicate = (id) => {
    Swal.fire({
      title: "Clone this BOM?",
      text: "This will create a new draft copy of this Bill of Materials.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Clone"
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(duplicateAdminBom({ id, payload: { as_revision: false } })).then((res) => {
          if (res?.payload?.success) {
            toast.success("BOM cloned successfully");
            dispatch(getAdminBomList());
          }
        });
      }
    });
  };

  const handleGeneratePr = (id, bomNo) => {
    Swal.fire({
      title: "Generate Store PR?",
      text: `Generate Purchase Requisition in Store for BOM ${bomNo}?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, Generate PR"
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(generatePrFromAdminBom(id)).then((res) => {
          if (res?.payload?.success) {
            toast.success(`Store PR Generated: ${res?.payload?.data?.voucher_no}`);
            dispatch(getAdminBomList());
          }
        });
      }
    });
  };

  return (
    <>
      <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
        <Header handleOpen={handleOpen} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="">Dashboard </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right"></i>
                    </li>
                    <li className="breadcrumb-item active">Bill of Materials List</li>
                  </ul>
                </div>
              </div>
            </div>

            {loading === false ? (
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-table show-entire">
                    <div className="card-body">
                      <div className="page-table-header mb-2">
                        <div className="row align-items-center">
                          <div className="col">
                            <div className="doctor-table-blk">
                              <h3>Bill of Materials List</h3>
                              <div className="doctor-search-blk">
                                <div className="top-nav-search table-search-blk">
                                  <form>
                                    <Search
                                      onSearch={(value) => {
                                        setSearch(value);
                                        setCurrentPage(1);
                                      }}
                                    />
                                    {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                    <a className="btn">
                                      <img
                                        src="/assets/img/icons/search-normal.svg"
                                        alt="search"
                                      />
                                    </a>
                                  </form>
                                </div>
                                <div className="add-group">
                                  <Link
                                    to="/admin/manage-bom"
                                    className="btn btn-primary add-pluss ms-2"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Add"
                                  >
                                    <img
                                      src="/assets/img/icons/plus.svg"
                                      alt="plus-icon"
                                    />
                                  </Link>
                                  <button
                                    type="button"
                                    onClick={handleRefresh}
                                    className="btn btn-primary doctor-refresh ms-2"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Refresh"
                                  >
                                    <img
                                      src="/assets/img/icons/re-fresh.svg"
                                      alt="refresh"
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                            <DropDown
                              limit={limit}
                              onLimitChange={(val) => setlimit(val)}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="table-responsive">
                        <table className="table border-0 custom-table comman-table mb-0 datatable">
                          <thead>
                            <tr>
                              <th>Sr.</th>
                              <th>BOM No</th>
                              <th>Party / Client Name</th>
                              <th>Subject / Scope</th>
                              <th>Total Amount</th>
                              <th>Total Qty.</th>
                              <th className="text-end">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {commentsData?.map((elem, i) => (
                              <tr key={elem?._id}>
                                <td>{(currentPage - 1) * limit + i + 1}</td>
                                <td>
                                  <strong>{elem?.bom_no}</strong>
                                  {elem?.version > 0 && (
                                    <span className="badge bg-secondary ms-1" style={{ fontSize: "9px" }}>v{elem.version}</span>
                                  )}
                                </td>
                                <td>{elem?.client_snapshot?.name || elem?.client_id?.name || "-"}</td>
                                <td>
                                  <div className="text-truncate" style={{ maxWidth: "260px" }} title={elem?.subject}>
                                    {elem?.subject || "-"}
                                  </div>
                                </td>
                                <td>{Number(elem?.grand_total || elem?.taxable_amount || 0).toFixed(2)}</td>
                                <td>{Number(elem?.total_assemblies_count || elem?.assemblies?.length || 1).toFixed(2)}</td>

                                <td className="text-end">
                                  <div className="dropdown dropdown-action">
                                    <a
                                      href="#"
                                      className="action-icon dropdown-toggle"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i className="fa fa-ellipsis-v"></i>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end">
                                      <button
                                        type="button"
                                        className="dropdown-item"
                                        onClick={() =>
                                          navigate("/admin/manage-bom", {
                                            state: { id: elem?._id },
                                          })
                                        }
                                      >
                                        <i className="fa-solid fa-pen-to-square m-r-5"></i>
                                        Edit
                                      </button>
                                      <button
                                        type="button"
                                        className="dropdown-item"
                                        onClick={() =>
                                          navigate(`/admin/view-bom/${elem?._id}`)
                                        }
                                      >
                                        <i className="fa-solid fa-eye m-r-5"></i>
                                        View Details
                                      </button>
                                      <button
                                        type="button"
                                        className="dropdown-item"
                                        onClick={() =>
                                          handleDuplicate(elem?._id)
                                        }
                                      >
                                        <i className="fa-solid fa-copy m-r-5"></i>
                                        Clone / Duplicate
                                      </button>
                                      <button
                                        type="button"
                                        className="dropdown-item"
                                        onClick={() =>
                                          handleDownloadPdf(elem?._id)
                                        }
                                      >
                                        <i className="fa fa-download m-r-5"></i>
                                        Download PDF
                                      </button>
                                      <button
                                        type="button"
                                        className="dropdown-item"
                                        onClick={() =>
                                          handleExportExcel(elem?._id)
                                        }
                                      >
                                        <i className="fa-solid fa-file-excel m-r-5"></i>
                                        Export Excel
                                      </button>
                                      {!elem?.pr_generated && (
                                        <button
                                          type="button"
                                          className="dropdown-item"
                                          onClick={() =>
                                            handleGeneratePr(elem?._id, elem.bom_no)
                                          }
                                        >
                                          <i className="fa fa-paper-plane m-r-5"></i>
                                          Generate Store PR
                                        </button>
                                      )}
                                      <button
                                        type="button"
                                        className="dropdown-item text-danger"
                                        onClick={() =>
                                          handleDelete(elem?._id, elem.bom_no)
                                        }
                                      >
                                        <i className="fa fa-trash-alt m-r-5"></i>
                                        Delete
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}

                            {commentsData?.length === 0 ? (
                              <tr>
                                <td colSpan="999">
                                  <div className="no-table-data">
                                    No Data Found!
                                  </div>
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        </table>
                      </div>

                      <div className="row align-center mt-3 mb-2">
                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                          <div
                            className="dataTables_info"
                            id="DataTables_Table_0_info"
                            role="status"
                            aria-live="polite"
                          >
                            Showing {Math.min(limit, totalItems)} from{" "}
                            {totalItems} data
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                          <div
                            className="dataTables_paginate paging_simple_numbers"
                            id="DataTables_Table_0_paginate"
                          >
                            <Pagination
                              total={totalItems}
                              itemsPerPage={limit}
                              currentPage={currentPage}
                              onPageChange={(page) => setCurrentPage(page)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Loader />
            )}
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default BomList;
